// MessageListByDate.jsx
import React, { useEffect, useState } from 'react';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import LoadingAll from '../loadingAll';
import { GET_DATA } from '../../services/API';

export default function MessageListModal({ isOpen, onClose, assistantId, externalReference }) {
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);

    // agrupa as mensagens por data (dd/mm/aaaa)
    const groups = messages.reduce((acc, msg) => {
        const day = new Date(msg.dateEvent).toLocaleDateString();
        if (!acc[day]) acc[day] = [];
        acc[day].push(msg);
        return acc;
    }, {});

    // estado de quais grupos estão abertos
    const [openGroups, setOpenGroups] = useState(
        Object.keys(groups).reduce((acc, day) => ({ ...acc, [day]: true }), {})
    );

    const toggleGroup = (day) => {
        setOpenGroups(prev => ({ ...prev, [day]: !prev[day] }));
    };

    useEffect(() => {
        (async () => {
            try {
                if (!isOpen) {
                    setMessages([]);
                    return;
                }

                setLoading(true);
                const mensagens = await GET_DATA(`MessageHistory/GetAllMessageHistory?assistantId=${assistantId}&externalReference=${externalReference}&maxItens=100`);

                setMessages(mensagens.data);
                setLoading(false);

            } catch (error) {
                setLoading(false);
            }
        })();
    }, [externalReference, isOpen]);

    if (!isOpen && messages) return null;

    if (loading) return <LoadingAll />

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
                className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
                onClick={onClose}
            />

            <div className="relative z-10 bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6">
                <header className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Mensagens</h2>
                    <button onClick={onClose} className="p-1 hover:bg-gray-200 rounded-full dark:hover:bg-gray-700">
                        <X className="w-6 h-6 text-gray-600 dark:text-gray-300" />
                    </button>
                </header>

                <div className="w-full max-w-xl mx-auto p-4 space-y-4">
                    {Object.entries(groups).map(([day, msgs]) => (
                        <div key={day} className="border border-gray-200 dark:border-gray-700 rounded-lg">
                            {/* Header do grupo */}
                            <button
                                onClick={() => toggleGroup(day)}
                                className="w-full flex items-center justify-between px-4 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition rounded-t-lg"
                            >
                                <span className="font-medium text-gray-800 dark:text-gray-100">{day}</span>
                                {openGroups[day]
                                    ? <ChevronUp className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                                    : <ChevronDown className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                                }
                            </button>

                            {/* Mensagens */}
                            {openGroups[day] && (
                                <ul className="px-4 py-2 space-y-3">
                                    {msgs.map(msg => {
                                        return (
                                            <li key={msg.id} className="flex">
                                                {msg.role === 'user' ? (
                                                    <div className="ml-auto max-w-[70%] bg-blue-500 text-white p-3 rounded-lg rounded-br-sm">
                                                        {msg.message}
                                                        <div className="text-xs text-blue-100 mt-1 text-right">
                                                            {new Date(msg.dateEvent).toLocaleTimeString()}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="mr-auto max-w-[70%] bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 p-3 rounded-lg rounded-bl-sm">
                                                        {msg.message}
                                                        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                            {new Date(msg.dateEvent).toLocaleTimeString()}
                                                        </div>
                                                    </div>
                                                )}
                                            </li>
                                        )
                                    })}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}